import { memo } from 'react';
import { format } from 'date-fns';
import { da } from 'date-fns/locale';
import { TranslationKey } from '~/lib';
import { useTranslation } from '~/shared/utils/translation';
import { Text } from '~/shared/components/Text/Text';
import { TCampaignLifeCycle } from '../ProductCard.definition';

const CampaignLifeCycleComponent = (props: TCampaignLifeCycle) => {
    const { translate } = useTranslation();

    if (!props || props?.type === 'none') {
        return null;
    }

    const startDate = props?.startDate
        ? format(new Date(props?.startDate), 'dd.MM.yyyy', { locale: da })
        : '';
    const endDate = props?.endDate
        ? format(new Date(props?.endDate), 'dd.MM.yyyy', { locale: da })
        : '';

    return (
        <Text>
            <strong>
                {translate(`campaign.${props?.type}` as TranslationKey, {
                    ...props,
                    startDate,
                    endDate,
                })}
            </strong>
        </Text>
    );
};

export const CampaignLifeCycle = memo(CampaignLifeCycleComponent);
